import React from 'react';
import '../../styles/styles.css';

export default function udupi() {
  return (
    <div className="container mt-4">
        <div className="row">
            {/* Left Large Image Box */}
            <div className="col-md-4 box1">
            <img src="/images/udupisrikrishna.jpeg" alt="Sri Krishna" />    
            </div>

            {/* Right Information Boxes */}
            <div className="col-md-8">
                <div className="Reg-box2">
                    <p><strong>Next Important Festival Dates<br />
    Saptosava Chariot Procession : 09th January, 2026 - 14th January, 2026<br />    
    <br />

  </strong></p>
  <p>Udipi Krishna Temple Info Site : <a href="https://krishnamatha.org/" target="_blank" rel="noopener noreferrer">
  Shri Krishna Math Website
</a>
</p>
         </div>
            </div>
        </div>

        {/* Bottom Full Width Description Box */}
        <div className="row mt-3">
            <div className="col-12 Desc-box3">
             <p>Sri Krishna Temple in Udupi is an important pilgrimage site in South India and Lord Krishna is depicted here as a small boy (Balakrishna). Kanakana Kindi: A small window through which Lord Krishna is believed to have given darshan to his ardent devotee, saint Kanakadasa. According to legend, Kanakadasa was of a low caste and was not allowed entry to the temple. Undaunted, he went behind the temple and prayed to the Lord through a small crack in the wall. Pleased, the statue of Lord Krishna turned around and gave him darshan. Just adjacent is the Kanakadasa Mantapa, which houses a statue of the saint. Udupi Sri Krishna temple and Matha (Monastery) were set up by Sri Madhwacharya (popular Vaishnava Saint) during the 13th century. Sri Krishna temple offers free meals to every devotee.</p>
           </div>
        </div>
   <div className="row mt-3">
        <div className="col-12">
          <div className="Desc-box3">
            <h2 className="live-header">Udupi Sri Krishna Temple</h2>
            <div className="youtube-container">
              <iframe
                src="https://www.youtube.com/embed/_n2vW635gMQ?rel=0&modestbranding=1&showinfo=0"
                title="Udupi Sri Krishna Temple"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              ></iframe>
            </div>
          </div>

  </div>
</div>
</div>
  )
}

